var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialStudies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeWidth: 1.5,
    d: "M13.79 25.9v-2.37A10.2 10.2 0 0 1 24 13.33a10.2 10.2 0 0 1 10.2 10.2V26zM11.09 26.01h25.82M12.89 26.01v13.62M34.58 26.01v13.62M24.4 13V6.13a.13.13 0 0 1 .13-.13h4.34a.3.3 0 0 1 .3.3v2.89a.3.3 0 0 1-.3.3h-4.25M9 40h10.46M28.54 40h10.64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    strokeWidth: 1.492,
    d: "M24 33.84A2.42 2.42 0 1 0 24 29a2.42 2.42 0 0 0 0 4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    strokeWidth: 1.492,
    d: "M24 33.83a3.93 3.93 0 0 1 3.93 3.93v3a.91.91 0 0 1-.91.91H21a.91.91 0 0 1-.91-.91v-3A3.93 3.93 0 0 1 24 33.83Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 5h32.18v37.43H8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialStudies);
export default __webpack_public_path__ + "static/media/socialStudies.b2860631c2695fcfe1f96e1596681f4b.svg";
export { ForwardRef as ReactComponent };